export default "__VITE_ASSET__MVZbXgbh__"